// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voting__header-btn-wrapper[data-v-5f8e3a78]{margin-left:auto;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}", ""]);
// Exports
module.exports = exports;
